/**
 * PDSPagination Utils
 */

export const genPaginationRangeButtons = function (
  totalPages: number,
  currentPage: number,
  neighborPageRange: number = 2
) {
  const ELLIPSES = '...'
  const pages = []
  //
  const firstPage = 1
  const lastPage = totalPages

  // Neighboring page elements
  let lowerNeighborBound = currentPage
  let upperNeighborBound = currentPage
  let lowerExtra = 0
  let upperExtra = 0

  // Distributes initial neighboring pagination elements
  let neighbors = neighborPageRange * 2
  let hasChanged = true
  while (neighbors > 0 && hasChanged) {
    hasChanged = false

    if (neighbors && lowerNeighborBound > firstPage) {
      hasChanged = true
      lowerNeighborBound -= 1
      neighbors--
    }
    if (neighbors && upperNeighborBound < lastPage) {
      hasChanged = true
      upperNeighborBound += 1
      neighbors--
    }
  }

  // Manages edge cases
  if (lowerNeighborBound <= firstPage + 1) {
    upperExtra += 1
  }
  if (upperNeighborBound >= lastPage - 1) {
    lowerExtra += 1
  }
  if (lowerNeighborBound <= firstPage) {
    upperExtra += 1
  }
  if (upperNeighborBound >= lastPage) {
    lowerExtra += 1
  }
  if (lowerExtra) lowerNeighborBound -= lowerExtra
  if (upperExtra) upperNeighborBound += upperExtra

  // Forces all bounds to be within pagination range
  if (lowerNeighborBound < firstPage) {
    lowerNeighborBound = firstPage
  }
  if (upperNeighborBound > lastPage) {
    upperNeighborBound = lastPage
  }

  // First Page
  pages.push(firstPage)

  let page = firstPage + 1

  // Handles lower "extra pages" content
  if (page < lowerNeighborBound) {
    const content = page + 1 === lowerNeighborBound ? page : ELLIPSES
    pages.push(content)
    page = lowerNeighborBound
  }

  // Add neighboring pages while within the end bound
  while (page <= upperNeighborBound && page <= lastPage) {
    pages.push(page)

    page++
  }

  // Handles upper "extra pages" content
  if (page < lastPage) {
    const content =
      upperNeighborBound + 1 === lastPage - 1
        ? upperNeighborBound + 1
        : ELLIPSES
    pages.push(content)
  }

  // Add last page if necessary
  if (page <= lastPage) {
    pages.push(lastPage)
  }

  return pages
}
